import React, {Component} from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
import { Link } from 'react-router-dom';

import $ from 'jquery';

import WP from 'WP';
import api from 'api';

import css from 'css';

import {calculateDiscountPercentage, cookie, gtmPush, refreshExpirationDate} from 'helpers';

import AnimateIn from 'partials/AnimateIn';
import Container from 'partials/Container';

import CloseIcon from 'images/CloseIcon';
import Info from 'images/Info';


import {
    addCheckoutOpportunityCourse,
    addCheckoutOpportunityProgram,
    setProductSearchKeyword,
    setProductDeliveryFilter,
    setProductAcademicAreaFilter,
    setProductCategoryFilter,
    setProductTypeFilter,
    setProductObjectTypeFilter,
    setProductProgramFilter,
    setProductCourseFilter,
    resetProductsFilter,
    removeCheckoutOpportunityCourse,
    removeCheckoutOpportunityProgram
} from 'store';

const CategoryList = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    flex: 0 0 100%;
    max-width: 100%;

    @media (min-width: 768px) {
        margin-top: 30px;
        flex: 0 0 40%;
        max-width: 40%;
    }

    ul {
        display: flex;
        flex-flow: column;
        margin: 0;
        padding: 0;
        list-style: none;

        > div {
            display: flex;
            flex-flow: column;
            padding-bottom: 30px;
        }

        li {
            position: relative;
            display: inline-flex;
            color: ${css.colors.main};
            padding: 15px 0;

            input[type=radio] {
                position: absolute;
                visibility: hidden;
            }

            .menu-tooltip {
                @media (max-width: 768px) {
                    position: initial;
                    padding: 0px 5px;
                }
            }

            label {
                display: inline-block;
                padding: 0 10px 0 40px;
                font-size: 1.35em;
                z-index: 9;
                cursor: pointer;
                -webkit-transition: all 0.25s linear;

                b {
                    font-weight: bold;
                }
            }

            .check {
                display: block;
                position: absolute;
                border: 1px solid #95B9DB;
                border-radius: 100%;
                height: 26px;
                width: 26px;
                cursor: pointer;
                z-index: 5;
                transition: border .25s linear;
                -webkit-transition: border .25s linear;

                &::before {
                    display: block;
                    position: absolute;
                    content: '';
                    border-radius: 100%;
                    height: 10px;
                    width: 10px;
                    top: 7px;
                    left: 7px;
                    margin: auto;
                    transition: background 0.25s linear;
                    -webkit-transition: background 0.25s linear;
                }
            }
        }
    }

    input[type=radio]:checked {
        ~ .check {
            border: 1px solid #133A6C;

            &::before{
                background: #133A6C;
            }
        }

        ~ label{
            color: #000000;
        }
    }
`;

const ProductList = styled.div`
    position: relative;
    flex: 0 0 100%;
    max-width: 100%;
    margin: 0 0 60px;

    @media (min-width: 768px) {
        margin: 30px 0 60px;
        flex: 0 0 60%;
        max-width: 60%;
    }

    .category {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        padding: 15px;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #DCDCDC;
        cursor: pointer;

        .name {
            font-size: 24px;
        }

        .arrow {
            position: relative;
            height: 15px;
            width: 15px;

            &.open {
                &::before {
                    transform: rotate(45deg);
                }
                &::after {
                    transform: rotate(-45deg);
                }
            }

            &::before, &::after {
                position: absolute;
                bottom: 0px;
                width: 0.15rem;
                height: 100%;
                transition: all 0.5s;
                content: "";
            }

            &::before {
                left: -5px;
                transform: rotate(-45deg);
                background-color: ${css.colors.main};
            }

            &::after {
                left: 5px;
                transform: rotate(45deg);
                background-color: ${css.colors.main};
            }
        }

        @media (max-width: 768px) {
            width: 100%;
        }
    }

    .products {
        width: 100%;
        display: none;

        &.expanded {
            display: block;
        }

        .summary {
            padding: 15px;
            font-size: 16px;

            a {
                display: inline-block;
                text-decoration: underline;
            }
        }
    }
    .nested-products{
        margin-left: 25px;
        width: calc(100% - 25px);
    }

    #about-text {
        margin-top: 40px;
        
        * {
            font: revert !important;
            font-weight: revert;
            padding: revert;
            margin: revert; 
        }
        & ul {
            list-style: decimal;
            
        }
        & ol {
            list-style: circle;
        }

        & a {
            text-decoration: underline;
        }
        blockquote {
            font-family: 'Spectral', serif; 
            font-weight: 700;
            font-size:24px;
            line-height:32px;
            position:relative;
        }
        blockquote:before {
            content: '';
            display: block;
            width:2px;
            height:100%;
            position:absolute;
            left:-24px;
            top:0;
            background: #006CEF;
        }
        blockquote p {
            font-family: 'Spectral', serif; 
            font-weight: 700;
            font-size:24px;
            line-height:32px;
        }
        blockquote p:before {
            content: '«';
            padding-right:5px;
        }
        blockquote p:after {
            content: '»';
            padding-left:5px;
        }
    }
`;

const ProductItem = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;

    justify-content: space-between;
    padding: 15px;

    &:hover {
        background-color: ${css.colors.pink};
    }

    @media (min-width: 850px) {
        align-items: center;
        flex-direction: row;
    }


    > .description {
        display: flex;
        flex: 0 0 40%;
        flex-flow: column;
        padding: 0 15px;

        @media (min-width: 850px) {
            padding: 0;
        }

        .name {
            padding-bottom: 5px;
            font-weight: bold;
        }

        .period {
            padding-bottom: 5px;
            font-weight: bold;
        }

        .readMore {
            padding-bottom: 5px;
            font-size: 13px;
            padding-left: 5px;
            font-weight: normal;
        }
    }

    > .totals {
        display: flex;
        flex: 0 0 30%;
        flex-flow: column;
        padding: 0 15px;

        @media (min-width: 850px) {
            padding: 0;
        }

        .price {
            padding-left: 10px;
        }

        .full-price {
            align-items: center;

            @media (min-width: 850px) {
                flex-direction: row-reverse;
            }

            .description {
                @media (min-width: 850px) {
                    display: none;
                }
            }

            .price {
                font-weight: bold;
            }
        }

        .discount-price {
            align-items: center;
        }

        &.has-discount {
            .full-price {
                @media (min-width: 850px) {
                    flex-direction: row;
                }

                .description {
                    @media (min-width: 850px) {
                        display: initial;
                    }
                }

                .price {
                    font-weight: normal;
                    text-decoration: line-through;
                }
            }

            .discount-price .price {
                font-weight: bold;
            }
        }

        & > div {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
    }

    > .action {
        z-index: 9999;

        button {
            width: 100%;
            background: ${css.colors.blue};
            padding: 10px 15px;
            margin-top: 10px;
            border-radius: 25px;
            color: white;
            text-align: start;
            cursor: pointer;

            @media (min-width: 850px) {
                text-align: center;
                width: 100px;
                margin-top: 0;
            }

            &.inCart {
                text-indent: -9999px;
                cursor: pointer;

                &:before {
                    position: absolute;
                    background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTYgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5QYWdlIDEgQ29weTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iY2hlY2tib3hfY2hlY2tlZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQuMDAwMDAwLCAtNy4wMDAwMDApIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGFnZS0xLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjAwMDAwMCwgMTIuNTAwMDAwKSByb3RhdGUoLTI3MC4wMDAwMDApIHRyYW5zbGF0ZSgtMTIuMDAwMDAwLCAtMTIuNTAwMDAwKSAiIHBvaW50cz0iNy41IDUuNSAxNi41IDE0LjMyMjMzMzIgMTEuMjc4MTk4MiAxOS41Ij48L3BvbHlsaW5lPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+') no-repeat;
                    background-position: center left;
                    width: 100%;
                    height: 1em;
                    left: 15px;
                    content: "";

                    @media (min-width: 850px) {
                        background-position: center center;
                        left: 0;
                    }
                }
            }
        }
    }
`;

const CourseToolTip = styled.div`
    position: absolute;
    width: 100%;
    left: -150px;

    @media (max-width: 768px) {
        left: 0px;
    }

    .container {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        z-index: 1;
        padding: 50px;
        border-radius: 6px;
        background-color: #e4effd;
        color: #000000;
        visibility: ${props => props.visible ? 'visible' : 'hidden'};

        span {
            h1 {
                ${css.fonts.SSProSemiBold};
                font-size: 24px;
                line-height: 34px;
            }
        }

        &::after {
            content: "";
            position: absolute;
            bottom: 100%;
            visibility: ${props => props.visible ? 'visible' : 'hidden'};
            left: 50%;
            margin-left: -10px;
            border-width: 10px;
            border-style: solid;
            border-color: #e4effd transparent transparent transparent;
            transform: rotate(180deg);
        }

        .closeIcon {
            position: absolute;
            right: 0;
            top: 0;
            padding-top: 20px;
            padding-right: 20px;
        }
    }
`;

const MenuToolTip = styled.div`
    color: #000000;
    .tooltip-text {
        font-size: 1em;
        line-height: 1.5em;
        visibility: hidden;
        max-width: 250px;
        background-color: #e4effd;
        color: #000000;
        text-align: center;
        border-radius: 6px;
        padding: 10px;
        position: absolute;
        z-index: 99999;
        top: 20px;
        left: 0;
        opacity: 0;
        transition: .3s;
        transform: translate3d(0px, 20px, 0px);
        width: 400px;
        padding: 20px;
        @media (max-width: 768px) {
            top: 50px;
        }
        &::after {
            content: "";
            position: absolute;
            bottom: 100%;
            visibility: hidden;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #e4effd transparent transparent transparent;
            transform: rotate(180deg);
        }
    }
    &:hover .tooltip-text {
        visibility: visible;
        opacity: 1;
        transform: translate3d(0px, 0px, 0px);
    }
    svg {
        height: 15px;
        width: 15px;
    }
`;

class Courses extends Component {
    constructor() {
        super();

        this.state = {
            expandedItem: null,
            expandedFilter: null,
            activeToolTip: null,
            aboutText: null,
        }
    }

    componentDidMount() {
        api.coursesFetcher.getAll();
        api.programsFetcher.getAll();

        api.getMenuByLocation('primary_filter_menu');
        api.getMenuByLocation('secondary_filter_menu');

        this._getCookies();
    }

    componentWillUnmount() {
        this.mounted = false;
        this.props.resetProductsFilter();
    }

    _onAddToCartClick(product, saveCookie = true) {
        if (refreshExpirationDate()) {
            return;
        }

        if (this._isInCart(product)) {
            if(saveCookie) {
                this._onHandleRemoveCartItem(product);
            }
        } else {
            this._onAddCartItemTracking(product);
            switch (product.objectType) {
                case 'program':
                    this.props.addCheckoutOpportunityProgram(product);
                    break;
                case 'course':
                    this.props.addCheckoutOpportunityCourse(product);
                    break;
            }
            if (saveCookie) {
                this._addCookie(product);
            }
        }
    }

    _onAddCartItemTracking(product) {
        gtmPush({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': 'NOK',
                'add': {
                    'products': [{
                        'name': product.name,
                        'id': product.id,
                        'price': product.price,
                        'brand': 'bjorknesprivatskole',
                        'category': product.academicArea || product.category || '',
                        'variant': product.semester,
                        'quantity': 1
                    }]
                }
            }
        });
    }

    _getCookies() {
        if (!cookie.get('shoppingCart')) {
            cookie.set('shoppingCart', JSON.stringify([]), 1);
        }
        const cookies = JSON.parse(cookie.get('shoppingCart'));
        cookies.map(function (cookies) {
            this._onAddToCartClick(cookies, false); //ADD ON SHOPPING CART
            this._isInCart(cookies); //SHOW ITEMS ON SHOPPING CART
        }, this);
    }

    _addCookie(product) {
        try {
            if (!cookie.get('shoppingCart')) {
                cookie.set('shoppingCart', JSON.stringify([]), 1);
            }
            const cookies = JSON.parse(cookie.get('shoppingCart'));
            cookies.push(product);
            cookie.set('shoppingCart', JSON.stringify(cookies), 1);
        } catch (e) {
            console.log("ERROR: ", e);
        }
    }

    _removeCookie(product) {
        if (!cookie.get('shoppingCart')) {
            cookie.set('shoppingCart', JSON.stringify([]), 1);
        }
        let cookies = JSON.parse(cookie.get('shoppingCart'));
        cookies = cookies.filter(function (cookie){
            return cookie.id !== this.id || cookie.offeringId !== this.offeringId;
        }, product);
        cookie.set('shoppingCart', JSON.stringify(cookies), 1);
    }

    _isInCart(product) {
        const {courses, programs} = this.props.opportunity;
        switch (product.objectType) {
            case 'program':
                return programs.filter(item => item.id === product.id).length;
            case 'course':
                return courses.filter(item => item.offeringId === product.offeringId).length;
        }
    }

    _onHandleRemoveCartItem = async (product) => {
        this._removeCookie(product);
        switch (product.objectType) {
            case 'course':
                await this.props.removeCheckoutOpportunityCourse(product);
                break;
            case 'program':
                await this.props.removeCheckoutOpportunityProgram(product);
                break;
        }
    }

    _expandProductCategory(categoryName) {
        setTimeout(() => {
            $('html, body').animate({
                scrollTop: $('#category-' + categoryName).offset().top
            }, 300);
        }, 100);

        this.setState({
            expandedItem: this.state.expandedItem === categoryName ? null : categoryName
        });
    }

    _expandProductFilter(filterName) {
        setTimeout(() => {
            $('html, body').animate({
                scrollTop: $('#filter-' + filterName).offset().top
            }, 300);
        }, 100);

        this.setState({
            expandedFilter: this.state.expandedFilter === filterName ? null : filterName,
            expandedItem: null
        });
    }

    _hasSearch() {
        return !!this.props.productSearchKeyword;
    }

    _hasFilter() {
        return !!Object.entries(this.props.productsFilter).filter(([key, value], i) => !!value).length;
        ;
    }

    _shouldExpandProductCategory(category) {
        return (this.state.expandedItem === category || this._hasSearch() || WP.is_bot);
    }

    _shouldExpandProductFilter(filter) {
        return (this.state.expandedFilter === filter || this._hasSearch() || WP.is_bot);
    }

    _hasProductFilter(product) {
        const {productsFilter} = this.props;

        const hasSearch = this._hasSearch();
        const hasFilter = this._hasFilter();

        let isSearched = false;
        let isFiltered = false;

        if(productsFilter.delivery){
            const [category1, category2] = productsFilter.delivery.split('-');
            if(this._isTermFiltered(product.delivery,  category1) ||
                this._isTermFiltered(product.delivery,  category2)){
                isFiltered = true;
            }
        }

        if (this._isKeywordOnSearch(product.keywords)) {
            isSearched = true;
        }

        if (this._isTermFiltered(product.delivery, productsFilter.delivery)) {
            isFiltered = true;
        }

        if (this._isTermFiltered(product.name, productsFilter.program)) {
            isFiltered = true;
        }

        if (this._isTermFiltered(product.name, productsFilter.course)) {
            isFiltered = true;
        }

        if (this._isTermFiltered(product.objectType, productsFilter.objectType)) {
            isFiltered = true;
        }

        if (product.academicArea !== undefined && this._isTermFiltered(product.academicArea, productsFilter.academicArea)) {
            isFiltered = true;
        }

        if (product.category !== undefined && this._isTermFiltered(product.category, productsFilter.category)) {
            isFiltered = true;
        }

        if (product.type !== undefined && this._isTermFiltered(product.type, productsFilter.type)) {
            isFiltered = true;
        }

        if (hasSearch && hasFilter) {
            return isSearched && isFiltered;
        }

        return (!hasSearch && !hasFilter) || (hasSearch && isSearched) || (hasFilter && isFiltered);
    }

    _isKeywordOnSearch(keywords) {
        const {productSearchKeyword} = this.props;

        if (!productSearchKeyword) {
            return false;
        }

        const searchable = keywords.split('||').map(string => string.toLowerCase().trim());
        const matches = searchable.filter(string => string.includes(productSearchKeyword.toLowerCase().trim()));

        if (matches.length === 0) {
            return false;
        }

        return true;
    }

    _isTermFiltered(term, filter) {
        if (!filter) {
            return false;
        }

        if (term.toLowerCase().trim() !== filter.toLowerCase().trim()) {
            return false;
        }

        return true;
    }

    _onProductFilterChange = (event) => {
        const {productsFilter} = this.props;

        let {value, dataset} = event.target
        let filter = dataset.valueType;

        this.props.resetProductsFilter();


        if ('custom' === filter) {
            const customFilter = value.split('#');

            if (customFilter.length > 1) {
                const customFilterParameters = customFilter[1].split('=');

                filter = customFilterParameters[0];
                value = customFilterParameters[1];
            }
        }

        switch (filter) {
            case 'academic-area':
                if (productsFilter.academicArea !== value) {
                    this.props.setProductAcademicAreaFilter(value);
                    break;
                }

                event.target.checked = false;
                break;
            case 'category':
                if (productsFilter.category !== value) {
                    this.props.setProductCategoryFilter(value);
                    break;
                }

                event.target.checked = false;
                break;
            case 'courses':
                if (productsFilter.couse !== value) {
                    this.props.setProductCourseFilter(value);
                    break;
                }

                event.target.checked = false;
                break;
            case 'delivery':
                if (productsFilter.delivery !== value) {
                    this.props.setProductDeliveryFilter(value);
                    break;
                }

                event.target.checked = false;
                break;
            case 'programs':
                if (productsFilter.program !== value) {
                    this.props.setProductProgramFilter(value);
                    break;
                }

                event.target.checked = false;
                break;
            case 'type':
                if (productsFilter.type !== value) {
                    this.props.setProductTypeFilter(value);
                    break;
                }

                event.target.checked = false;
                break;
            case 'object-type':
                if (productsFilter.objectType !== value) {
                    this.props.setProductObjectTypeFilter(value);
                    break;
                }

                event.target.checked = false;
                break;
        }
        const { primaryFilterMenu, secondaryFilterMenu } = this.props;
        const filters = [...primaryFilterMenu, ...secondaryFilterMenu];

        const selectedFilter = filters.find(filter => filter.url === event.target.value)
        if(selectedFilter && this.state.aboutText !== selectedFilter.about){
            this.setState({
                aboutText: selectedFilter.about
            });
        } else{
            this.setState({
                aboutText: ''
            });
        }
    }

    _mapProdutsToList() {
        const {courses, programs} = this.props;

        let categorizedCourses = courses.filter(course => !!course.academicArea);
        let categorizedPrograms = programs.filter(program => !!program.category);

        let categorizedList = [];

        categorizedCourses.forEach(course => {
            course.objectType = 'course';

            if (!this._hasProductFilter(course)) {
                return;
            }

            if (!categorizedList[course.academicArea]) {
                categorizedList[course.academicArea] = {
                    slug: course.academicAreaSlug,
                    products: []
                };
            }

            categorizedList[course.academicArea].products.push(course);
        });

        categorizedPrograms.forEach(program => {
            program.objectType = 'program';

            if (!this._hasProductFilter(program)) {
                return;
            }

            if (!categorizedList[program.category]) {
                categorizedList[program.category] = {
                    slug: program.categorySlug,
                    products: []
                };
            }

            categorizedList[program.category].products.push(program);
        });

        categorizedList = Object.keys(categorizedList).sort().reduce(function (result, key) {
            result[key] = categorizedList[key];

            result[key].products.sort((a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                if(a.semester < b.semester) {
                    return -1;
                }

                if(a.semester > b.semester) {
                    return 1;
                }
                return 0;
            });

            return result;
        }, {});

        return categorizedList;
    }

    _onHandleDisplayToolTip(index, display = true)
    {
        return display ? this.setState({ activeToolTip : index }) : this.setState({activeToolTip : null });
    }

    render() {
        const { primaryFilterMenu, secondaryFilterMenu } = this.props;
        const { activeToolTip } = this.state;

        const products = this._mapProdutsToList();

        return (
            <AnimateIn>
                <Container flex wrap>
                    <CategoryList>
                        <ul>
                            <div className="primary-filter">
                                {primaryFilterMenu.map(item => {
                                    return (
                                        <React.Fragment key={'menu-filter-' + item.id}>
                                            <li>
                                                <label htmlFor={'menu-filter-' + item.id}><b> {item.title} </b></label>
                                                <input onClick={this._onProductFilterChange.bind(this)} type="radio"
                                                        id={'menu-filter-' + item.id}
                                                        value={item.object == 'custom' ? item.url : item.title}
                                                        data-value-type={item.object} name="selector"/>
                                                <div className="check">
                                                    <div className="inside"></div>
                                                </div>
                                                {item.description &&
                                                    <MenuToolTip className="menu-tooltip">
                                                        <Info />
                                                        <span className="tooltip-text">
                                                            {item.description}
                                                        </span>
                                                    </MenuToolTip>
                                                }
                                            </li>
                                        </React.Fragment>
                                    )
                                })}
                            </div>
                            <div className="secundary-filter">
                                {secondaryFilterMenu.map(item => {
                                    return (
                                        <React.Fragment key={'menu-filter-' + item.id}>
                                            <li>
                                                <label htmlFor={'menu-filter-' + item.id}> {item.title} </label>
                                                <input onClick={this._onProductFilterChange.bind(this)} type="radio"
                                                        id={'menu-filter-' + item.id}
                                                        value={item.object == 'custom' ? item.url : item.title}
                                                        data-value-type={item.object} name="selector"/>
                                                <div className="check">
                                                    <div className="inside"></div>
                                                </div>
                                                {item.description &&
                                                    <MenuToolTip className="menu-tooltip">
                                                        <Info />
                                                        <span className="tooltip-text">
                                                            {item.description}
                                                        </span>
                                                    </MenuToolTip>
                                                }
                                            </li>
                                        </React.Fragment>
                                    )
                                })}
                            </div>
                        </ul>
                    </CategoryList>
                    <ProductList>
                        {(this.props.productsFilter.delivery === "nett-stream") 
                            ? this._renderGroupedList(products, activeToolTip)
                            : this._renderProductList(products, activeToolTip)
                        }
                        {this.state.aboutText ? (
                            <div 
                                id="about-text"
                                dangerouslySetInnerHTML={{ __html: this.state.aboutText }}
                            />
                        ): ( null )}
                    </ProductList>
                    <div className='about'>
                        {}

                    </div>
                </Container>
            </AnimateIn>
        );
    }

    _renderProductList(products, activeToolTip, isNested){
    return Object.entries(products).map(([categoryName, data]) => {
        return (
            <React.Fragment key={'category-' + data.slug}>
                <div id={'category-' + data.slug}>
                    <div className="category" onClick={e => this._expandProductCategory(data.slug)}>
                        <div className="name">
                            {categoryName}
                        </div>
                        <div
                            className={this._shouldExpandProductCategory(data.slug) ? 'open arrow' : 'arrow'}></div>
                    </div>
                    <div
                        className={this._shouldExpandProductCategory(data.slug) ? 'products expanded' : 'products'}>
                        <div className="summary">
                            <Link to={'/fag/' + data.slug}> Les om emnetilbudet </Link>
                        </div>
                        {data.products.map(product => {
                            const inCart = this._isInCart(product);
                            let fullPrice = product.price;
                            let discountedPrice = null;
                            
                            if (product.price < product.originalPrice) {
                                fullPrice = product.originalPrice;
                                discountedPrice = product.price;
                            
                            }
                            return (
                                <ProductItem key={'product-' + product.offeringId + Math.random(20)}>
                                    <div className="description">
                                        <div className="name">
                                            <span dangerouslySetInnerHTML={{ __html: product.name }} />
                                            {product.description && product.description.length && <span onClick={() => this._onHandleDisplayToolTip(product.offeringId)} className="readMore">Les mer</span>}
                                        </div>
                                        <div className="period">
                                            {product.isFixedStart
                                                ? product.semester + ((product.semester && product.weeklyHours) ? ': ' : '') + (product.weeklyHours ? product.weeklyHours + ' timer i uken' : '')
                                                : product.duration ? 'Nett: Tilgang i ' + product.duration + ' semestre' : ''
                                            }
                                        </div>
                                    </div>
                                    <div
                                        className={discountedPrice ? "totals has-discount" : "totals"}>
                                        <div className="full-price">
                                            <span
                                                className="description"> {discountedPrice ? "Fullpris" : "Pris"} </span>
                                            <span
                                                className="price"> {parseInt(fullPrice).toLocaleString('de-DE')},- </span>
                                        </div>
                                        {discountedPrice &&
                                        <div className="discount-price">
                                            <span
                                                className="description"> Rabattert pris ({calculateDiscountPercentage(product.originalPrice, product.price)}%) </span>
                                            <span
                                                className="price"> {parseInt(discountedPrice).toLocaleString('de-DE')},- </span>
                                        </div>
                                        }
                                    </div>
                                    <div className="action">
                                        <button onClick={e => this._onAddToCartClick(product)}
                                                className={inCart ? 'inCart' : ''}> Legg til
                                        </button>
                                    </div>
                                    <CourseToolTip className="tooltip" visible={product.offeringId === activeToolTip}>
                                        <div className="container">
                                            <div className="closeIcon" onClick={() => this._onHandleDisplayToolTip(product.offeringId, false)}><CloseIcon color="#000000" /> </div>
                                            <span dangerouslySetInnerHTML={{ __html: product.description }} />
                                        </div>
                                    </CourseToolTip>
                                </ProductItem>
                            )
                        })}
                    </div>
                </div>
            </React.Fragment>
        )
    })}

    _renderGroupedList(products, activeToolTip) {
        const nettProducts = Object.keys(products).reduce((result, key) => {
            const nettProducts = products[key].products.filter(product => product.delivery === 'Nett');
            if (nettProducts.length > 0) {
                result[key] = {
                    slug: products[key].slug,
                    products: nettProducts
                };
            }
            return result;
        }, {});
        const streamingProducts = Object.keys(products).reduce((result, key) => {
            const streamingProducts = products[key].products.filter(product => product.delivery === "Stream");
            if (streamingProducts.length > 0) {
                result[key] = {
                    slug: products[key].slug,
                    products: streamingProducts
                };
            }
            return result;
        }, {});

        return (
            <React.Fragment>
                {Object.keys(streamingProducts).length
                ?(<div id={'filter-stream'}>
                    <div className="category" onClick={e => this._expandProductFilter("stream")}>
                        <div className="name">
                            Nettstudier Stream
                        </div>
                        <div
                            className={this._shouldExpandProductFilter("stream") ? 'open arrow' : 'arrow'}></div>
                    </div>
                    <div
                        className={`${this._shouldExpandProductFilter("stream") ? 'products expanded' : 'products'} nested-products`}
                    >
                        {this._shouldExpandProductFilter("stream")
                            ? this._renderProductList(streamingProducts, activeToolTip, true)
                            : null
                        }
                    </div>
                </div>
                ) : null
                }
                {Object.keys(nettProducts).length
                ?(<div id={'filter-net'}>
                    <div className="category" onClick={e => this._expandProductFilter("net")}>
                        <div className="name">
                            Nettstudier Fleks
                        </div>
                        <div
                            className={this._shouldExpandProductFilter("net") ? 'open arrow' : 'arrow'}></div>
                    </div>
                    <div
                        className={`${this._shouldExpandProductFilter("net") ? 'products expanded' : 'products'} nested-products`}
                    >
                        {this._shouldExpandProductFilter("net") 
                            ?  this._renderProductList(nettProducts, activeToolTip, true) 
                            : null
                        }
                    </div>
                </div>
                ) : null
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    primaryFilterMenu: state.menus.primary_filter_menu ? state.menus.primary_filter_menu.items : [],
    secondaryFilterMenu: state.menus.secondary_filter_menu ? state.menus.secondary_filter_menu.items : [],
    opportunity: state.opportunity,
    courses: state.courses.posts,
    programs: state.programs.posts,
    productSearchKeyword: state.productSearchKeyword,
    productsFilter: state.productsFilter
});

const actions = {
    addCheckoutOpportunityCourse,
    addCheckoutOpportunityProgram,
    setProductSearchKeyword,
    setProductDeliveryFilter,
    setProductAcademicAreaFilter,
    setProductCategoryFilter,
    setProductTypeFilter,
    setProductObjectTypeFilter,
    setProductProgramFilter,
    setProductCourseFilter,
    resetProductsFilter,
    removeCheckoutOpportunityCourse,
    removeCheckoutOpportunityProgram
}

export default connect(mapStateToProps, actions)(Courses);



// WEBPACK FOOTER //
// ./src/partials/modules/Courses/Courses.js